import { Card, Grid, InputBase, Paper, Typography } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import {
  addInternalNoteByPetId,
  getPetDetailsById,
  getPetDetailsByIdNew,
  getPetsCompliantSummary,
} from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";

const InternalNotes = ({
  intrnalNoteModVsble,
  setIntrnalNoteModVsble,
  updatedApp,
  appoinment,
}) => {
  const dispatch = useDispatch();
  const [notes, setNotes] = useState("");
  const [limitExceedErr, setLimitExceedErr] = useState(false);
  const comPetDet = useSelector(
    (state) => state?.pet?.complaintSummary?.data?.pet,
  );
  const petDetails = useSelector((state) => state?.pet?.petDetailsNew);
  const apntId = appoinment?.appoinment?.appointmentId;
  const petId = appoinment?.appoinment?.petId;
  const petData = petDetails;

  // useEffect(() => {
  //   setNotes(petData?.internalNotes?.[0]?.notes?.trim());
  // }, [petData]);

  const handleModClose = () => {
    setIntrnalNoteModVsble(false);
    setNotes("");
    setLimitExceedErr(false);
  };

  const handleUpdate = () => {
    dispatch(getPetDetailsByIdNew(petId));
    // if (apntId) {
    //   dispatch(getPetsCompliantSummary(updatedApp?.appointmentId ?? apntId));
    // } else {
    //   dispatch(getPetDetailsById(petId));
    // }
    setNotes("");
    setLimitExceedErr(false);
    // handleModClose();
  };

  const handleSaveIntenalNote = () => {
    const reqObj = {
      petId: apntId ? updatedApp?.petId : petId,
      data: { notes: notes?.trim() },
    };
    // if (petData?.internalNotes?.[0]) {
    //   reqObj.noteId = petData?.internalNotes?.[0]?.internalId;
    //   dispatch(updateInternalNoteByPetAndNoteId(reqObj)).then((res) => {
    //     if (res?.payload) handleUpdate();
    //   });
    //   return;
    // }
    dispatch(addInternalNoteByPetId(reqObj)).then((res) => {
      if (res?.payload) handleUpdate();
    });
  };

  const handleChangeNote = (value) => {
    if (value?.length > 300) return setLimitExceedErr(true);
    setNotes(value);
    setLimitExceedErr(false);
  };

  const getInternalNotes = () => {
    return (
      [...(petData?.internalNotes ?? [])]?.sort(
        (a, b) => new Date(a?.createdDate) - new Date(b?.createdDate),
      ) ?? []
    );
  };

  return (
    <CustomModal
      open={intrnalNoteModVsble}
      onClose={handleModClose}
      header="Internal Notes"
      modal
      modalWidth={70}
      headerCenter
    >
      <div className="scroll-60vh">
        <Grid container className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {getInternalNotes()?.map((li) => (
              <Card
                sx={{ borderColor: AppColors.white, padding: 2 }}
                key={li?.internalId}
                className=" mt15"
              >
                <Typography className="blue-color fs14 font-bold">
                  {li?.userName}
                </Typography>
                <Typography className="gray13 fs10 font-medium">
                  {moment(new Date(li?.createdDate)).format(
                    "DD MMM YYYY | HH:mm",
                  )}
                </Typography>

                <div className="flex-row mt5">
                  <Typography className="black29 fs14 txt-regular">
                    {li?.notes}
                  </Typography>
                </div>
              </Card>
            ))}
          </Grid>

          <div className="flex-row-ali-cen mv10 w100Per">
            {/* Input Box */}
            <div className="w90Per">
              <Paper
                component="form"
                sx={{
                  p: "2px 8px",
                  display: "flex",
                  alignItems: "center",
                  background: AppColors.white,
                  borderRadius: "10px",
                  height: 40,
                  width: "100%",
                  border: `1px solid ${AppColors.gray}`,
                  margin: "10px 0px",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Type here..."
                  inputProps={{
                    "aria-label": "Type here...",
                  }}
                  value={notes}
                  onChange={(e) => handleChangeNote(e?.target?.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSaveIntenalNote();
                      e.preventDefault();
                    }
                  }}
                />
              </Paper>
            </div>

            {/* Send Button */}
            <div className="flex1-end">
              <div
                className="sndBtnBack cursor flex-center"
                onClick={handleSaveIntenalNote}
              >
                <img
                  src={require("../../../../assets/images/png/Send2.png")}
                  alt="send"
                  className="img-wh25"
                />
              </div>
            </div>
          </div>

          {/* <div className="flex1-end mt20">
            <div>
              <CustomButton
                text={petData?.internalNotes?.[0]?.notes ? "Update" : "Save"}
                smallBtn
                onClick={handleSaveIntenalNote}
              />
            </div>
          </div> */}
        </Grid>
      </div>
    </CustomModal>
  );
};

export default InternalNotes;
